import "./App.css";
import ChatBody from "./ChatBody";

function App() {
  return (
    <div className="App">
      <ChatBody />
    </div>
  );
}

export default App;
